<template>
    <div v-show="isShow" class="videoClip-container">
        <div class="videoClip-content">
            <div class="title">截取封面</div>
            <div @click="close" class="close"></div>
            <div ref="clipVideoc" @click="toggleVideo(true)" class="video">
                <video ref="clipVideo" :src="(info.content && info.content.url) || info.url"></video>
                <div :style="'left:'+left+'px; top:'+top+'px'" @mouseenter.prevent="isBorderClick=false" @mouseout.prevent="isBorderClick=false;" @mousedown.prevent="isBorderClick=true;setStart($event)" @mouseup.prevent="isBorderClick=false;"
                            @mousemove.prevent="slideBorderMove" ref="border" :class="{border: true, row: isRow}"></div>
                <!-- <div :style="'left:'+left+'px; top:'+top+'px'" ref="border" :class="{border: true, row: isRow}"></div>  -->
            </div>
            <div class="progress-container">
                <i @click="toggleVideo(false)" :class="{playBtn: true, on: isPlay}"></i>
                <div ref="line" class="progress">
                    <p @click="isMouseClick=true;clickJump($event)" class="fill"></p>
                    <p :style="'width:'+audioPercent" @click="isMouseClick=true;clickJump($event)" class="line">
                        <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                            @mousemove.prevent="slideMouseMove"></i>
                    </p>
                </div>
                <div class="time">{{nowTime}} / {{duration}}</div>
            </div>
            <div class="btn-container">
                <p @click="cutPic">确定</p>
                <p @click="close">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
import common from '@common/common'
import {apis} from '@common/config'

export default {
    data() {
        return {
            saveleftW: 0,
            left: 223,
            saveleft: 0,
            savetopW: 0,
            top: 46,
            savetop: 0,
            info: {},
            isPlay: false,
            isShow: false,
            isBorderClick: false,
            isMouseClick: false,
            percent: 0,
            audioPercent: '0%',
            isRow: false,
            nowTime: '00:00',
            duration: '00:00',
            appId: '',
            appSecret: '',
            uploadUrl: '',
            _XN_upCfg: null,
            c: null,
            pic: {
                // 图片部分数据模型
                types: [],
                assets: []
            },
            video: {
                // 视频部分数据模型
                types: [],
                assets: []
            },
            audio: {
                // 音频部分数据模型
                types: [],
                assets: []
            }
        }
    },
    methods: {
        open(info,c) {
            console.log(info)
            this.c = c
            this.getAsperaConfig()
            common.getFileConfigs()
            .then(r => {
                this.appId = r.app_id
                this.appSecret = r.app_secret
                this.uploadUrl = r.url
            })
            if(info.content.resolution){
                let x = info.content.resolution.split('x')
                if(Number(x[0]) > Number(x[1])){
                    this.isRow = true
                    this.top = 0;
                    this.left = 189;
                }else{
                    this.isRow = false
                    this.top = 46;
                    this.left = 223;
                }
            }
            this.info = info;
            this.isShow = true

            this.$nextTick(() => {
                this.$refs.clipVideo.addEventListener('loadedmetadata',(e) => {
                    console.log(e.target.videoWidth)
                    this.duration = this.s2hms(this.$refs.clipVideo.duration)
                    // console.log(this.s2hms(this.$refs.clipVideo.duration));
                })

                this.$refs.clipVideo.addEventListener('timeupdate',() => {
                    this.nowTime = this.s2hms(this.$refs.clipVideo.currentTime)
                    let width = ((this.$refs.clipVideo.currentTime / this.$refs.clipVideo.duration) * 100).toFixed(2)
                    this.percent = width;
                    this.audioPercent = width + '%';
                    // console.log(this.s2hms(this.$refs.clipVideo.duration));
                })

                this.$refs.clipVideo.addEventListener('ended',() => {
                    this.isPlay = false
                })

                const video = this.$refs.clipVideo;
                video.setAttribute("crossorigin",'Anonymous')
            })
        },
        close() {
            if(this.$refs.clipVideo){
                this.isPlay = false;
                this.$refs.clipVideo.pause()
            }
            this.c(false)
            this.isShow = false;
        },
        getAsperaConfig() {
            // 获取aspera上传配置
            return common.myFetch(apis.File_Aspera)
            .then(r => {
                if (r) {
                    const types = r.file_format;
                    this.pic.types = types.image;
                    this.video.types = types.video;
                    this.audio.types = types.audio;

                    this._XN_upCfg = {
                        asperaPath: r.aspera_path,
                        httpPath: r.original_path,
                        fileNameId: r.filename_id
                    }
                }
            })
        },
        dataURLtoBlob(dataurl) {
            var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new Blob([u8arr], {
                type: mime
            });
        },
        streamUpload(name, file) {
            console.log(file)
            var that = this;
            var upConfig = this._XN_upCfg
            var filename = name
            var uniname = common.uniKey()
            var platform = common.getPlatform()
            var ext = file.type.split('/').pop()
            var fileNameId = upConfig.fileNameId
            var httpPath = upConfig.httpPath
            var path = httpPath + '/' + fileNameId + platform + uniname + '.' + ext

            const info = { 
                targetPath: path,
                appId: this.appId,
                appSecret: this.appSecret
            };

            var _url = this.uploadUrl + "/streamUpload?targetPath="+info.targetPath+"&appId="+info.appId+"&appSecret="+info.appSecret;
            var _xhr = new XMLHttpRequest;

            _xhr.ontimeout = function () {
                console.error('The request for ' + _url + ' timed out.');
            };

            _xhr.onreadystatechange = function() {
                console.log(_xhr.responseText)
                if (_xhr.readyState != 4 || _xhr.status < 200)
                return false;
                let data = JSON.parse(_xhr.responseText)
                if(data.success){
                    console.log(data)
                    data.targetPath = data.path;
                    data.name = name;
                    data.time = that.$refs.clipVideo.currentTime
                    that.addAssetsToPage([data])
                }else{
                    that.$imgLoading.close()
                    that.showSelect = false;
                    that.showFail = true;
                    that.canEditImg = true
                    that.alertWord = '网络连接超时'
                }
            }

            _xhr.timeout = 60 * 1000;
            _xhr.open("POST", _url, !0);
            _xhr.send(file);
        },
        checkFileType(f) {
            // 检查文件类型
            let type = "";
            let ext = f.path.split(".").pop() || f.name.split(".").pop();
            ext = ext.toLowerCase();

            if (this.pic.types.indexOf(ext) > -1) {
                type = 1;
            } else if (this.video.types.indexOf(ext) > -1) {
                type = 2;
            } else if (this.audio.types.indexOf(ext) > -1) {
                type = 3;
            }

            return type;
        },
        async addAssetsToPage(data) {
            console.log('更新到接口', data);
            const filelist = [];
            data.forEach(i => {
                console.log(i)
                const type = this.checkFileType(i);
                // 将文件名改为截取前40位加后缀名
                const fileName = i.pureName || i.title || i.filename || i.name || "";
                const nameParts = fileName.split(".")[0];
                const ext = i.path.split('/').pop().split('.').pop();
                let nameLeft = nameParts;
                nameLeft = nameLeft.substr(0, 40);
                const filetitle = `${nameLeft}.${ext}`;
                console.log(filetitle)

                let file = {};

                file = {
                    type: type,
                    title: filetitle,
                    path: i.targetPath || i.path,
                    subject_id: this.info.d,
                    subject_type: 5,
                    time: i.time
                };
                

                filelist.push(file);
            });

            const info = { file_info: JSON.stringify(filelist) };
            return common.myFetch(apis.File_add, info).then(r => {
                if (r) {
                    // console.log(r)
                    r.list[0].time = filelist[0].time
                    this.c(r)
                    this.close()
                }else{
                    // this.c(false)
                    this.close()
                }
            });
        },
        async cutPic(){
            if(this.$refs.clipVideo){
                this.isPlay = false;
                this.$refs.clipVideo.pause()
            }
            
            let videoLeft = this.$refs.clipVideo.getBoundingClientRect().left
            let videoTop = this.$refs.clipVideo.getBoundingClientRect().top
            let borderLeft = this.$refs.border.getBoundingClientRect().left
            let borderTop = this.$refs.border.getBoundingClientRect().top

            const canvas = document.createElement('canvas');
            const canvasCtx = canvas.getContext('2d');
            const video = this.$refs.clipVideo;
            // video.setAttribute("crossorigin",'Anonymous')
            // return false
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            canvasCtx.fillStyle = '#222125';
            canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
            const imgWidth = Math.min(canvas.width, video.videoWidth * canvas.height / video.videoHeight);
            const imgHeight = Math.min(canvas.height, video.videoHeight * canvas.width / video.videoWidth);
            canvasCtx.drawImage(
            video,
            0,
            0,
            video.videoWidth,
            video.videoHeight,
            (canvas.width - imgWidth) / 2,
            (canvas.height - imgHeight) / 2,
            imgWidth,
            imgHeight,
            );
            const MIME_TYPE = 'image/png'; // 保存文件类型
            const imgURL = canvas.toDataURL(MIME_TYPE);
            console.log(imgURL)
            // this.clipPic(imgURL)
            if(this.isRow){
                let pic = await this.handleImg({
                    src: imgURL,
                    rect: {
                    x: borderLeft - videoLeft, // 截取方格左上角横坐标
                    y: 0, // 截取方格左上角纵坐标
                    width: 275, // 截取方格宽度
                    height: 367 // 截取方格高度
                    }
                })

                let file = this.dataURLtoBlob(pic)
                this.streamUpload(this.info.title,file)
            }else{
                let pic = await this.handleImg({
                    src: imgURL,
                    rect: {
                    x: borderLeft - videoLeft, // 截取方格左上角横坐标
                    y: borderTop - videoTop, // 截取方格左上角纵坐标
                    width: 206, // 截取方格宽度
                    height: 275 // 截取方格高度
                    }
                })

                let file = this.dataURLtoBlob(pic)
                this.streamUpload(this.info.title,file)
            }
            // let pic = await this.handleImg({
            //     src: imgURL,
            //     rect: {
            //     x: 189, // 截取方格左上角横坐标
            //     y: 0, // 截取方格左上角纵坐标
            //     width: 275, // 截取方格宽度
            //     height: 367 // 截取方格高度
            //     }
            // })

            // let file = this.dataURLtoBlob(pic)
            // this.streamUpload(this.info.title,file)
            // console.log(file)
            
        },
        handleImg (opts) {
            return new Promise((resolve, reject) => {
                const { src, rect } = opts
                if (!src || !rect) {
                reject(new Error('opts params Error!'))
                }
                const img = new Image()
                img.src = src
                img.onload = function () {
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                const { x, y, width, height } = rect
                canvas.width = width
                canvas.height = height
                ctx.drawImage(this, x, y, width, height, 0, 0, width, height)
                const url = canvas.toDataURL('image/png')
                resolve(url)
                }
                img.onerror = function (err) {
                reject(err)
                }
            })
        },
        clipPic(url) {
            var img = new Image();
            img.src = url;
            img.onload = () => {
                let videoLeft = this.$refs.clipVideo.getBoundingClientRect().left
                let videoTop = this.$refs.clipVideo.getBoundingClientRect().top
                let borderLeft = this.$refs.border.getBoundingClientRect().left
                let borderTop = this.$refs.border.getBoundingClientRect().top
                const canvas = document.createElement('canvas');
                const canvasCtx = canvas.getContext('2d');
                const video = this.$refs.clipVideo;
                canvas.width = 275;
                canvas.height = 367;
                canvasCtx.fillStyle = '#222125';
                canvasCtx.fillRect(0, 0, canvas.width, canvas.height);
            }
            
        },
        s2hms(time) {
            var min = Math.floor(time % 3600);
            var hh =
                Math.floor(time / 3600) < 10
                ? "0" + Math.floor(time / 3600)
                : Math.floor(time / 3600);
            var mm =
                Math.floor(min / 60) < 10
                ? "0" + Math.floor(min / 60)
                : Math.floor(min / 60);
            var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
            if(Number(hh) > 0){
                mm = Number(hh)*60 + Number(mm)
            }
            return mm + ":" + ss;
            // console.log(hh + ":" + mm + ":"+ ss)
        },
        hms2s(time) {
            var hour = time.split(':')[0];
            var min = time.split(':')[1];
            var sec = time.split(':')[2];
            return Number(hour*3600) + Number(min*60) + Number(sec);
        },
        toggleVideo(bol) {
            if(bol){
                this.isPlay = false;
                this.$refs.clipVideo.pause()
            }else{
                this.isPlay = !this.isPlay
                if(this.isPlay){
                    this.$refs.clipVideo.play()
                }else{
                    this.$refs.clipVideo.pause()
                }
            }
        },
        timeStop() {
            this.isPlay = false;
            this.$refs.clipVideo.pause()
            // this.$refs.audioDom.pause();
        },
        slideMouseMove(e) {
            // return false;
            if (this.isMouseClick) {
                let clientX = this.$refs.line.getBoundingClientRect().x;
                let width = this.$refs.line.getBoundingClientRect().width;
                let left = 0;
                let percent = 0;

                if (e.clientX - clientX <= 0) {
                    left = "0%";
                } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
                    left = "100%";
                } else {
                    percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
                    left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
                }

                // this.nowTime = this.s2hms(
                //     (this.$refs.audioDom.duration * percent) / 100
                // );

                this.percent = percent;
                this.audioPercent = left;

                // this.$refs.sliderLeft.style.width = left;
            }
        },
        setStart(e) {
            this.saveleft = e.clientX
            this.saveleftW = this.left
            this.savetop = e.clientY
            this.savetopW = this.top
        },
        slideBorderMove(e) {
            // return false;
            if (this.isBorderClick) {
                if(this.saveleftW + (e.clientX-this.saveleft) < 0){
                    this.left = 0
                }else if(this.saveleftW + (e.clientX-this.saveleft) > (this.$refs.clipVideo.getBoundingClientRect().width - this.$refs.border.getBoundingClientRect().width)) {
                    this.left = (this.$refs.clipVideo.getBoundingClientRect().width - this.$refs.border.getBoundingClientRect().width)
                }else{
                    this.left = this.saveleftW + (e.clientX-this.saveleft)
                }

                if(this.savetopW + (e.clientY-this.savetop) < 0){
                    this.top = 0
                }else if(this.savetopW + (e.clientY-this.savetop) > (this.$refs.clipVideo.getBoundingClientRect().height - this.$refs.border.getBoundingClientRect().height)) {
                    this.top = (this.$refs.clipVideo.getBoundingClientRect().height - this.$refs.border.getBoundingClientRect().height)
                }else{
                    this.top = this.savetopW + (e.clientY-this.savetop)
                }
            }
        },
        clickJump(e) {
            let clientX = this.$refs.line.getBoundingClientRect().x;
            let width = this.$refs.line.getBoundingClientRect().width;
            let left = 0;
            let percent = 0;

            if (e.clientX - clientX <= 0) {
                left = "0%";
            } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
                left = "100%";
            } else {
                percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
                left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
            }

            this.percent = percent;
            this.audioPercent = left;

            // console.log(this.percent)
            this.$refs.clipVideo.currentTime = this.$refs.clipVideo.duration*percent/100

            // this.$refs.sliderLeft.style.width = left;

            this.timeNavi();

            this.isMouseClick = false;
        },
        timeNavi() {
            if (this.isMouseClick) {
                let percent = this.percent / 100;
                let time = (percent * this.duration).toFixed(2);
                // this.$refs.audioDom.currentTime = time;
                // this.$refs.audioDom.play();
                // this.isPlay = true;
                this.isMouseClick = false;
            }
        }
    },
    mounted() {
        
    }
}
</script>

<style lang="less" scoped>
    .videoClip-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 9999;
        background: rgba(50,59,75,0.3);
        backdrop-filter: blur(1.6px);

        .videoClip-content {
            display: flex;
            flex-direction: column;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 712px;
            height: 576px;
            background: #FFFFFF;
            border-radius: 4px;
            transform: translate(-50%, -50%);
            padding: 20px 30px;
            box-sizing: border-box;

            .title {
                font-size: 24px;
                line-height: 31px;
                color: #050F0F;
                font-weight: bold;
                margin-bottom: 14px;
            }

            .close {
                position: absolute;
                top: 30px;
                right: 30px;
                width: 20px;
                height: 20px;
                background: url('./assets/close.png') no-repeat;
                background-size: 100% 100%;
                background-position: center center;
                user-select: none;
                cursor: pointer;
            }

            .video {
                position: relative;
                width: 652px;
                height: 367px;
                border-radius: 2px;
                overflow: hidden;

                video {
                    width: 100%;
                    height: 100%;
                }

                .border {
                    position: absolute;
                    top: 46px;
                    left: 223px;
                    width: 206px;
                    height: 275px;
                    background: rgba(255,84,86,0.1500);
                    border: 2px solid #FF5456;
                    box-sizing: border-box;

                    &.row {
                        top: 0px;
                        left: 189px;
                        width: 275px;
                        height: 367px;
                    }
                }
            }

            .progress-container {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                width: 652px;
                height: 44px;
                background: rgba(0,0,0,0.03);
                border-radius: 45px;
                margin: 20px 0;
                padding: 0 14px;
                box-sizing: border-box;

                .playBtn {
                    display: block;
                    width: 20px;
                    height: 20px;
                    user-select: none;
                    cursor: pointer;
                    background: url('../../assets/img/mediaPublish/playIcon.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        background: url('../../assets/img/mediaPublish/pauseIcon.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        user-select: none;
                        cursor: pointer;
                    }
                }

                .progress {
                    position: relative;
                    flex: 1;
                    min-width: 0;
                    height: 4px;
                    background: #CBCED2;
                    border-radius: 5px;
                    margin: 0 20px;
                    user-select: none;
                    cursor: pointer;

                    .fill {
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 1;
                        width: 100%;
                        height: 4px;
                    }

                    .line {
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 2;
                        width: 0%;
                        height: 4px;
                        background: #41B48C;
                        border-radius: 5px;

                        i {
                            position: absolute;
                            top: 50%;
                            right: -7px;
                            margin-top: -7px;
                            display: block;
                            width: 14px;
                            height: 14px;
                            background: #41B48C;
                            border-radius: 50%;
                        }
                    }
                }

                .time {
                    font-size: 12px;
                    color: #323B4B;
                }
            }

            .btn-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                p {
                    width: 120px;
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    border-radius: 4px;
                    color: #FFF;
                    background: #41B48C;
                    user-select: none;
                    cursor: pointer;

                    &:nth-last-of-type(1) {
                        background: #CBCED2;
                        margin-left: 20px;
                    }
                }
            }
        }
    }
</style>